import "./style.scss";
import {
  AreaChart,
  Area,
  XAxis,
  YAxis,
  CartesianGrid,
  Tooltip,
  ResponsiveContainer,
  Line,
  LineChart,
  Legend,
} from "recharts";
import { useEffect, useState } from "react";



const DepthChart = ({orderbook, totalBids, totalAsks}) => {

  const [formattedChart, setFormattedChart] = useState();
  const [bidsChart, setBidsChart] = useState([]);
  const [asksChart, setAsksChart] = useState([]);

  useEffect(() => {
    if(orderbook && totalBids && totalAsks) {
      let bids = orderbook.bids;
      let asks = orderbook.asks;
      let _bidsArray = [];
      let _asksArray = [];
      let longestLength = Math.max(bids.length, asks.length);
      for(let i = 0; i < longestLength; i++) {
        if(bids[i])
          _bidsArray.push({
            price: bids[i][0],
            bid: totalBids[i],
            amount: totalBids[i]
          })
        // else
        //   _bidsArray.push(_bidsArray[_bidsArray.length-1])
      }
      // _bidsArray.push({
      //   price: 0,
      //   bid: _bidsArray[_bidsArray.length-1].bid
      // })
      for(let i = 0; i < longestLength; i++) {
        if(asks[i])
          _asksArray.push({
            price: asks[i][0],
            ask: totalAsks[i],
            amount: totalAsks[i]
          })
        // else
        //   _asksArray.push(_asksArray[_asksArray.length-1])
      }
      // _asksArray= [{
      //   price: _asksArray[0].price-0.00001,
      //   ask: 0
      // }, ..._asksArray]
      console.log("FORMATTED", _bidsArray, _asksArray)

      setBidsChart(_bidsArray);
      setAsksChart(_asksArray);
      setFormattedChart([..._bidsArray.reverse(), ..._asksArray]);
    }
  },[orderbook, totalBids, totalAsks]);

  function calculateDepthRange() {
    try {
    if(bidsChart.length > 0 && asksChart.length > 0 && totalAsks && totalBids) {
     
      let centerPoint = (bidsChart[bidsChart.length - 1].price + asksChart[0].price) / 2;
      let low = centerPoint * (1 - 0.5);
      let high = centerPoint * (1 + 0.5);

      let id1 = 0, id2 = 0;
      while (id1 < asksChart.length && asksChart[id1].price < high) id1++; id1 = Math.max(0, id1 - 1);
      while (id2 < bidsChart.length && bidsChart[bidsChart.length - id2 - 1].price > low) id2++; id2 = Math.max(0, id2 - 1);
      return {
        X: [0, Math.max(totalAsks[id1], totalBids[id2]) * 1.25],
        Y: [ low, high]
      }
    }}
     catch {
    return {
      X: [ "auto", "auto"],
      Y: [ "auto", "auto"]
    }
  }
    
  }
  if(!formattedChart)
    return <>Loading</>
  else
  return <ResponsiveContainer width="100%" height="100%">
  <AreaChart
    data={formattedChart}
    layout={"vertical"}
    margin={{
      top: 0,
      right: 0,
      left: 0,
      bottom: 0,
    }}
  >
    <defs>
      <linearGradient id="color_green" x1="1" y1="0" x2="0" y2="0">
        <stop offset="0%" stopColor={"#187251"} stopOpacity={0.3} />
        <stop offset="100%" stopColor={"#187251"} stopOpacity={0.3} />
      </linearGradient>
      <linearGradient id="color_red" x1="1" y1="0" x2="0" y2="0">
        <stop offset="0%" stopColor="#761b1b" stopOpacity={0.4} />
        <stop offset="100%" stopColor="#761b1b" stopOpacity={0.4} />
      </linearGradient>
    </defs>
    <XAxis
      type={"number"}
      dataKey={"amount"}
      hide={false}
      mirror={true}
      axisLine={false}
      domain={calculateDepthRange().X}
      allowDataOverflow={true}
    />
    <Tooltip/>
    <YAxis 
      type={"number"}
      axisLine={false}
      tickCount={8}
      hide={false} 
      dataKey={"price"}
      reversed={true}
      domain={calculateDepthRange().Y}
      allowDataOverflow={true}
      mirror={true}
    />
    <Area
      isAnimationActive={false} 
      type="linear"
      dataKey="bid"
      strokeWidth={1.2}
      stroke={"var(--green700)"}
      fill={"url(#color_green)"}
    />
    <Area
      isAnimationActive={false} 
      type="linear"
      dataKey="ask"
      strokeWidth={1.2}
      stroke={"var(--red700)"}
      fill={"url(#color_red)"}
    />
  </AreaChart>
</ResponsiveContainer>
}

export default DepthChart;